import { render, staticRenderFns } from "./ComprobantesPendientesDePago.vue?vue&type=template&id=05de8a5b&"
import script from "./ComprobantesPendientesDePago.vue?vue&type=script&lang=js&"
export * from "./ComprobantesPendientesDePago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports